import type { CoverageDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useMemo } from 'react';
import IncludedCoverages from './IncludedCoverages';
import ExcludedCoverages from './ExcludedCoverages';
import { ListBox, Box } from '@flos/react-ui';
import useWindowSize from '../../hooks/useWindowSize';

const Coverages = ({
    shouldRenderTitle = false,
    showCoverableDetailsUI = false,
    coverages,
    flavourName,
    coverableId
}: {
    shouldRenderTitle?: boolean;
    showCoverableDetailsUI?: boolean;
    coverages: CoverageDTO[] | undefined;
    flavourName?: string;
    coverableId?: string;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = !isMobileDevice;
    const includedCoverages = useMemo(() => coverages?.filter((c) => c.selected), [coverages]);
    const excludedCoverages = useMemo(() => coverages?.filter((c) => !c.selected), [coverages]);
    return showCoverableDetailsUI ? (
        <div>
            <div className="u-spacing-inset-m--stretch-max">
                <ListBox title="Hvad er dækket?" isOpen>
                    <IncludedCoverages
                        showCoverableDetailsUI={showCoverableDetailsUI}
                        includedCoverages={includedCoverages}
                        shouldRenderTitle={shouldRenderTitle}
                        flavourName={flavourName ?? ''}
                        coverableId={coverableId ?? ''}
                    />
                </ListBox>
            </div>
            {(excludedCoverages?.length ?? 0) > 0 && (
                <div className="u-spacing-inset-m--stretch-max">
                    <ListBox title="Hvad er ikke dækket?" isOpen={listBoxIsOpen}>
                        <ExcludedCoverages
                            showCoverableDetailsUI={showCoverableDetailsUI}
                            excludedCoverages={excludedCoverages}
                            shouldRenderTitle={shouldRenderTitle}
                            flavourName={flavourName ?? ''}
                            coverableId={coverableId ?? ''}
                            includedCoverages={includedCoverages}
                        />
                    </ListBox>
                </div>
            )}
        </div>
    ) : (
        <div className="u-flex-box u-flex-box--col u-gap-3 u-gap-5@md">
            {!(includedCoverages?.length === 0) && (
                <Box className="u-border-none u-shadow-none">
                    <IncludedCoverages
                        showCoverableDetailsUI={showCoverableDetailsUI}
                        includedCoverages={includedCoverages}
                        shouldRenderTitle={shouldRenderTitle}
                        flavourName={flavourName ?? ''}
                        coverableId={coverableId ?? ''}
                    />
                </Box>
            )}
            {!(excludedCoverages?.length === 0) && (
                <Box className="u-border-none u-shadow-none">
                    <ExcludedCoverages
                        showCoverableDetailsUI={showCoverableDetailsUI}
                        excludedCoverages={excludedCoverages}
                        shouldRenderTitle={shouldRenderTitle}
                        flavourName={flavourName ?? ''}
                        coverableId={coverableId ?? ''}
                        includedCoverages={includedCoverages}
                    />
                </Box>
            )}
        </div>
    );
};

export default Coverages;
